import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { FilterPipe, OmitPipe } from './select-menu.pipe';
import { SelectMenuComponent } from './select-menu.component';

@NgModule({
  declarations: [FilterPipe, OmitPipe, SelectMenuComponent],
  imports: [BrowserModule, FormsModule, TranslateModule],
  exports: [SelectMenuComponent],
  providers: [],
  bootstrap: []
})
export class SelectMenuModule {}



// WEBPACK FOOTER //
// ./src/app/modules/tag-editor/select-menu/select-menu.module.ts